var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"id":"header"}}),_c('router-view',{attrs:{"id":"main"}}),_c('GoToTopButton'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDummy),expression:"!showDummy"}],attrs:{"id":"footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }